<div id="content" class="extensible">
  <div class="container">
    <div class="row">
      <div class="col-12 metrics-header">
        <div class="page-title">
          <h1>{{ page_title }}</h1>
        </div>
        <div class="metrics-filters-panel">
          <app-month-navigation
            [selected_month]="selectedMonth()"
            [can_go_to_next_month]="can_go_to_next_month()"
            [can_go_to_current_month]="can_go_to_current_month()"
            (previous_month)="goToPreviousMonth()"
            (next_month)="goToNextMonth()"
            (current_month)="goToCurrentMonth()"
          ></app-month-navigation>
        </div>
      </div>
    </div>

    @if (metrics(); as metricsData) {
      <section class="metrics-section">
        <div class="row section-header-row">
          <div class="col-12">
            <h2 class="section-title">Mi día a día</h2>
            <p class="metrics-page-subtitle">Métricas que te servirán para tu día a día</p>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <app-metric-card title="Horas a realizar hoy">
              <div class="big-numbers">
                <span>{{ formatHours(metricsData.today_expected_hours) }}</span>
              </div>
            </app-metric-card>
          </div>

          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <app-metric-card title="Horas fichadas / registradas">
              <div class="big-numbers">
                <span>
                  {{ metricsData.today_clocked_hours | hoursToHourString }} / {{ metricsData.today_registered_hours | hoursToHourString }}
                </span>
              </div>
            </app-metric-card>
          </div>

          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <app-metric-card title="Horas semanales" [hasChart]="true">
              <div class="big-numbers">
                <span>{{ metricsData.weekly_registered_hours | hoursToHourString }}</span>
                <span class="small-muted"> / {{ metricsData.weekly_expected_hours | hoursToHourString }}</span>
              </div>
              <div chart class="progress-container">
                @if (radialChartOptions(); as chartOptions) {
                  <apx-chart
                    [series]="chartOptions.series"
                    [chart]="chartOptions.chart"
                    [plotOptions]="chartOptions.plotOptions"
                    [colors]="chartOptions.colors"
                    [stroke]="chartOptions.stroke"
                  ></apx-chart>
                }
              </div>
            </app-metric-card>
          </div>

          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <app-metric-card title="Próximas vacaciones" icon="flight_takeoff">
              @if (metricsData.next_vacation_days !== null) {
                <div class="big-numbers">
                  <span>en {{ metricsData.next_vacation_days }} días</span>
                </div>
              } @else {
                <div class="big-numbers">
                  <span class="empty-text">Sin vacaciones programadas</span>
                </div>
              }
            </app-metric-card>
          </div>
        </div>
      </section>

      <section class="metrics-section category-filter-section">
        <div class="row section-header-row">
          <div class="col-12">
            <div class="category-filter">
              @for (filter of categoryFilters; track filter.value) {
                <button
                  type="button"
                  class="category-filter-button"
                  [class.active]="selectedKpiCategory() === filter.value"
                  (click)="setKpiCategoryFilter(filter.value)"
                >
                  {{ filter.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </section>

      @if (shouldShowBasicMetrics() && hasBasicMetrics()) {
        <section class="metrics-section">
          <div class="row section-header-row">
            <div class="col-12">
              <h2 class="section-title">Métricas básicas</h2>
              <p class="section-subtitle">
                Métricas básicas para un compromiso mínimo exigible. No cumplirlo, implicará una posible bajada salarial.
              </p>
            </div>
          </div>

          <div class="kpi-grid">
            @for (kpiCard of basicKpiCards(); track kpiCard.id) {
              <button
                type="button"
                (click)="openKpiCardPreviewDialog(kpiCard.rawData)"
                class="kpi-grid-card"
                [matTooltip]="kpiCard.tooltip"
                matTooltipPosition="below"
                matTooltipShowDelay="500"
              >
                <div class="kpi-grid-card-leading">
                  <span class="kpi-dot" [style.background-color]="kpiCard.statusColor"></span>
                  <span class="kpi-grid-card-title">{{ kpiCard.name }}</span>
                </div>
                <div class="kpi-grid-card-trailing">
                  <mat-icon class="kpi-eye-icon">visibility</mat-icon>
                </div>
              </button>
            }
          </div>
        </section>
      }

      @if (shouldShowCompanyProductMetrics()) {
        <section class="metrics-section">
          <div class="row section-header-row">
            <div class="col-12">
              <h2 class="section-title">Métricas de producto</h2>
            </div>
          </div>
          @if (hasCompanyProductMetrics()) {
            @for (companyProductGroup of companyProductKpiGroups(); track companyProductGroup.id) {
              <div class="company-product-group">
                <div class="company-product-group-chip">
                  <img
                    class="company-product-group-logo"
                    [src]="companyProductGroup.companyProductLogoUrl"
                    [alt]="companyProductGroup.companyProductName"
                  />
                  <span>{{ companyProductGroup.companyProductName }}</span>
                </div>
                <div class="kpi-grid">
                  @for (companyProductCard of companyProductGroup.cards; track companyProductCard.id) {
                    <button
                      type="button"
                      (click)="openKpiCardPreviewDialog(companyProductCard.rawData)"
                      class="kpi-grid-card"
                      [matTooltip]="companyProductCard.tooltip"
                      matTooltipPosition="below"
                      matTooltipShowDelay="500"
                    >
                      <div class="kpi-grid-card-leading">
                        <span class="kpi-dot" [style.background-color]="companyProductCard.statusColor"></span>
                        <span class="kpi-grid-card-title">{{ companyProductCard.metricName }}</span>
                      </div>
                      <div class="kpi-grid-card-trailing">
                        <mat-icon class="kpi-eye-icon">visibility</mat-icon>
                      </div>
                    </button>
                  }
                </div>

                <div class="kpi-grid my-company-product-grid">
                  @for (companyProductCard of companyProductGroup.myCompanyProductCards; track companyProductCard.id) {
                    <button
                      type="button"
                      (click)="openKpiCardPreviewDialog(companyProductCard.rawData)"
                      class="kpi-grid-card"
                      [matTooltip]="companyProductCard.tooltip"
                      matTooltipPosition="below"
                      matTooltipShowDelay="500"
                    >
                      <div class="kpi-grid-card-leading">
                        <span class="kpi-dot" [style.background-color]="companyProductCard.statusColor"></span>
                        <span class="kpi-grid-card-title">{{ companyProductCard.metricName }}</span>
                      </div>
                      <div class="kpi-grid-card-trailing">
                        <mat-icon class="kpi-eye-icon">visibility</mat-icon>
                      </div>
                    </button>
                  }
                </div>
              </div>
            }
          } @else {
            <p class="section-subtitle">Sin métricas de producto para este periodo.</p>
          }
        </section>
      }

      @if (!hasAnyMetrics()) {
        <section class="metrics-section">
          <p class="section-subtitle">No hay métricas para {{ selectedMonthLabel() }} con los filtros seleccionados.</p>
        </section>
      }
    }
  </div>
</div>
